import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';
import bgPopup from '../../assets/images/perfect_match/bg_popupUp.png';

const useQuizStyles = createUseStyles((theme: Theme) => {
    return {
        container: {
            width: '100%',
            minHeight: '100vh',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
        },
        subtitle: {
            fontFamily: theme.fonts.poplar,
            fontSize: 'clamp(1.2rem, 2.5vw, 1.9rem)',
            top: '1rem',
            color: theme.colors.ivory_beige,
            letterSpacing: 'clamp(0.15rem, 0.4vw, 0.3rem)',
            marginTop: '2rem',
        },
        backgroundImage: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0,
        },
        breweryImage: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
        },
        contentOverlay: {
            position: 'relative',
            zIndex: 1,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        },
        headerSection: {
            position: 'absolute',
            top: '0.1rem',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.5rem',
            zIndex: 3,
        },
        logoImage: {
            width: 'auto',
            height: 'clamp(170px, 17vh, 200px)',
            objectFit: 'contain',
        },
        questionSection: {
            position: 'relative',
            width: 'clamp(75%, 70vw, 85%)',
            height: 'clamp(45%, 50vh, 50%)',
            maxWidth: '1100px',
            padding: 'clamp(2rem, 3vh, 3rem) clamp(2.5rem, 4vw, 4rem) clamp(2.5rem, 3.5vh, 3.5rem)',
            backgroundImage: `url(${bgPopup})`,
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 'clamp(0.8rem, 1.2vh, 1.2rem)',
            zIndex: 2,
        },
        progressText: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(1rem, 1.5vw, 1.2rem)',
            fontWeight: 700,
            color: theme.colors.ivory_beige,
            letterSpacing: 'clamp(0.1rem, 0.25vw, 0.2rem)',
            marginBottom: '0.5rem',
            position: 'relative',
            display: 'inline-block',
            padding: '0 clamp(1.5rem, 2vw, 2rem)',
            '&::before, &::after': {
                content: '""',
                position: 'absolute',
                top: '50%',
                width: 'clamp(150px, 25vw, 250px)',
                height: '2px',
                backgroundColor: theme.colors.golden_mustard,
            },
            '&::before': {
                right: '100%',
                marginRight: 'clamp(0.7rem, 1vw, 1rem)',
            },
            '&::after': {
                left: '100%',
                marginLeft: 'clamp(0.7rem, 1vw, 1rem)',
            },
        },
        progressContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
        },
        questionBox: {
            width: '80%',
            padding: '0 clamp(0.5rem, 1vw, 1rem)',
        },
        questionText: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(1.4rem, 1.5vw, 1.7rem)',
            fontWeight: 100,
            color: theme.colors.ivory_beige,
            textAlign: 'center',
            letterSpacing: 'clamp(0.05rem, 0.12vw, 0.1rem)',
            marginBottom: '3rem',
            lineHeight: 1.3,
        },
        answersContainer: {
            display: 'flex',
            flexDirection: 'row',
            gap: 'clamp(1rem, 1.5vw, 1.5rem)',
            width: '90%',
            justifyContent: 'center',
            alignItems: 'stretch',
            marginTop: '-2.5rem',
        },
        answerButton: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(0.9rem, 1.2vw, 1.1rem)',
            fontWeight: 600,
            color: theme.colors.espresso_brown,
            backgroundColor: theme.colors.ivory_beige,
            border: 'none',
            borderRadius: '5px',
            padding: 'clamp(0.4rem, 0.6vh, 0.5rem) clamp(0.4rem, 0.6vw, 0.5rem)',
            textTransform: 'none',
            letterSpacing: '0.05rem',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            flex: 1,
            maxWidth: 'clamp(200px, 30vw, 250px)',
            textAlign: 'center',
            lineHeight: 1.4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 'clamp(50px, 7vh, 65px)',
            outline: 'none',
            WebkitTapHighlightColor: 'transparent',
            '&:hover': {
                backgroundColor: theme.colors.latte_cream,
                transform: 'translateY(-3px)',
                boxShadow: '0 0.5rem 1rem rgba(0,0,0,0.3)',
            },
            '&:focus': {
                backgroundColor: theme.colors.ivory_beige,
                transform: 'none',
                boxShadow: 'none',
            },
            '&:active': {
                backgroundColor: theme.colors.ivory_beige,
                transform: 'none',
                boxShadow: 'none',
            },
            '@media (hover: none)': {
                '&:hover': {
                    backgroundColor: theme.colors.ivory_beige,
                    transform: 'none',
                    boxShadow: 'none',
                },
            },
        },
        charactersSection: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            padding: '0 clamp(2rem, 4vw, 4rem)',
            pointerEvents: 'none',
            zIndex: 3,
        },
        characterLeft: {
            height: 'clamp(35vh, 42vh, 45vh)',
            width: 'auto',
            objectFit: 'contain',
            objectPosition: 'bottom left',
            transform: 'translateX(clamp(-3rem, -5vw, -5rem))',
        },
        characterCenter: {
            height: 'clamp(28vh, 32vh, 35vh)',
            width: 'auto',
            objectFit: 'contain',
            objectPosition: 'bottom center',
        },
        characterRight: {
            height: 'clamp(35vh, 42vh, 45vh)',
            width: 'auto',
            objectFit: 'contain',
            objectPosition: 'bottom right',
            transform: 'translateX(clamp(3rem, 5vw, 5rem))',
        },
        promoalcool: {
            position: 'absolute',
            bottom: '4.5rem',
            right: '5.5rem',
            width: '200px',
            height: 'auto',
            objectFit: 'contain',
            zIndex: 10,
        },
    };
});

export default useQuizStyles;